import React from "react";

import { TComplianceStatus } from "api/compliance/types";

import { Paragraph4 } from "ui/typography";

import { IComplianceStatusProps, TComplianceStatusStyles } from "./types";

const complianceStatusStyles: TComplianceStatusStyles = {
  pending: {
    color: "#344054",
    className: "bg-[#F2F4F7]",
  },
  approved: {
    color: "#027A48",
    className: "bg-[#ECFDF3]",
  },
  rejected: {
    color: "#B42318",
    className: "bg-[#FEF3F2]",
  },
  review: {
    color: "#B54708",
    className: "bg-[#FFFAEB]",
  },
  enrolled: {
    color: "#175CD3",
    className: "bg-[#EFF8FF]",
  },
  started: {
    color: "#175CD3",
    className: "bg-[#EFF8FF]",
  },
  "not-started": {
    color: "#344054",
    className: "bg-[#F2F4F7]",
  },
};

export const statusToTextMap: Record<TComplianceStatus, string> = {
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
  review: "Ready for Review",
  enrolled: "Enrolled",
  started: "Started",
  "not-started": "Not Started",
};

export const ComplianceStatus = (props: IComplianceStatusProps) => {
  const { status, text, className, customBgColor, customColor } = props;

  return (
    <Paragraph4
      fontWeight="500"
      lineHeight="18px"
      textColor={customColor ?? complianceStatusStyles[status]?.color}
      className={`py-[2px] px-2 rounded-2xl h-[22px] ${complianceStatusStyles[status]?.className} ${className}`}
      style={{
        backgroundColor: customBgColor ?? "",
      }}
    >
      {text}
    </Paragraph4>
  );
};
